jQuery(document).ready(function() {

    if ( document.getElementById('flipclock') ) {

        const eventDate = document.getElementById('flipclock').getAttribute('data-fcdate');
        const messageWrapper = document.querySelector('.flipclock__message');
        const futureDate  = new Date( eventDate );
        
        const el = document.querySelector('.clock');

        const clock = new FlipClock( el, futureDate, {

            autoStart: false,
            face: 'DayCounter',
            language:'sv-se',
            countdown: true
           
        });

        clock.on('start', ()=> {

            console.log('FlipClock => Started!');

        });

        clock.on('stop', ()=> {

            console.log('FlipClock => Stopped!');
            messageWrapper.innerHTML = '<h1>Nu kör vi! :)</h1>';
            
        });

        clock.start();
        //clock.stop();
         
    }
});